import {Component, Input} from '@angular/core';
import {Product} from '@spartacus/core';
import {DcpBundleTemplate} from '@dcp/configurator';
import {DcpProductUtilitiesService} from '../../../services/dcp-product-utilities.service';

@Component({
  selector: 'dcp-lead-form-success',
  templateUrl: './lead-form-success.component.html',
  styleUrls: ['./lead-form-success.component.scss']
})
export class LeadFormSuccessComponent {
  @Input() product: Product;
  externalUrl: string;

  constructor(
    private productUtilitiesService: DcpProductUtilitiesService,
  ) {
  }

  @Input() set bundleTemplate(bundleTemplate: DcpBundleTemplate) {
    this.externalUrl = this.productUtilitiesService.getExternalUrl(bundleTemplate);
  }
}
